import moment from 'moment'

import { Leave } from 'modules/shift_management/lib/types'

// Handling leaves that started the week before
export const leaveFirstCell = (leave: Leave, firstDay: moment.Moment) => {
  return moment(leave._startOn) <= moment(firstDay)
    ? moment(firstDay).weekday()
    : moment(leave._startOn).weekday()
}

// Handling leaves that end the week after or have on end date
export const leaveLastCell = (leave: Leave, lastDay: moment.Moment) => {
  return moment(leave._finishOn) >= moment(lastDay) || !leave._finishOn
    ? moment(lastDay).weekday() + 1
    : moment(leave._finishOn).weekday() + 1
}
